module.exports = __webpack_public_path__ + "img/feather-icons.3c41802f.svg";